import {get as _get} from "lodash";

export function isDeveloper (assignedRoles: any) {
    let isDeveloper = false
    if(Object.keys(assignedRoles).length !== 0 && assignedRoles.constructor === Object){
        Object.values(assignedRoles).forEach(function(resource) {
            const roles = _get(resource, "roles", {})
            if(roles && roles.length > 0){
                roles.forEach((role: any) => {
                    if(role === "developer"){
                        isDeveloper = true
                    }
                })
            }
        })
    }
    return isDeveloper
}

export function isAdmin(assignedRoles: any) {
    let isAdmin = false
    if(Object.keys(assignedRoles).length !== 0 && assignedRoles.constructor === Object){
        Object.values(assignedRoles).forEach(function(resource) {
            const roles = _get(resource, "roles", {})
            if(roles && roles.length > 0){
                roles.forEach((role: any) => {
                    if(role === "admin"){
                        isAdmin = true
                    }
                })
            }
        })
    }
    return isAdmin
}

export const hasRole = (assignedRoles: any, neededRole: string): boolean => {
    let foundRole = false
    if(Object.keys(assignedRoles).length !== 0 && assignedRoles.constructor === Object){
        Object.values(assignedRoles).forEach(function(resource) {
            const roles = _get(resource, "roles", {})
            if(roles && roles.length > 0){
                roles.forEach((role: any) => {
                    if(role === neededRole){
                        foundRole = true
                    }
                })
            }
        })
    }
    return foundRole
}
